import style from "./style.module.sass"
import { useTheme } from "@material-ui/core/styles"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import config from "../../../../config"

export default function LanguageLevelBar() {
    const { theme: { bgColors, colors } } = useTheme()
    const { t } = useTranslation()
    const resultData = useSelector(state => state.analyseData.result.resultData)
    const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
    const isContrast = themeState !== config.THEMES_MODES.LIGHT
    const languageLevel = resultData.formulaLanguageLevel || -1
    const languageLevelToString = config.languageLevelToString
    const textLanguageLevel = languageLevelToString.find(v => v.threshold < languageLevel)

    return <div className={style.firstPart} title={t('accessibility_analysis_language-level')} tabIndex={config.tabIndexes.languageLevelBarWrapper} style={{ backgroundColor: bgColors.bgPrimary0 }}>
        <p style={{ color: isContrast ? colors.colorContrast : colors.colorPrimary500 }} className={`${style.title}`}>{t("ai_gen_lang_level")}</p>
        <div className="d-flex align-items-center justify-content-center" >
            <h1 style={{ color: isContrast ? colors.colorContrast : textLanguageLevel ? textLanguageLevel.color : colors.colorPrimary700, fontSize: '3rem' }} >
                {textLanguageLevel ? textLanguageLevel.level : ''}
            </h1>
        </div>
    </div>
}